import { render } from "./Demonstrate.vue?vue&type=template&id=d277141e"
import script from "./Demonstrate.vue?vue&type=script&lang=js"
export * from "./Demonstrate.vue?vue&type=script&lang=js"

import exportComponent from "/app/widget-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__